import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToggleOff = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 14C15.3125 14 18 16.6312 18 20C18 23.3125 15.3125 26 12 26C8.63125 26 6 23.3125 6 20C6 16.6312 8.63125 14 12 14ZM8 20C8 22.2062 9.79375 24 12 24C14.2062 24 16 22.2062 16 20C16 17.7938 14.2062 16 12 16C9.79375 16 8 17.7938 8 20ZM28 30H12C6.47687 30 2 25.525 2 20C2 14.475 6.47687 10 12 10H28C33.525 10 38 14.475 38 20C38 25.525 33.525 30 28 30ZM28 12H12C7.58187 12 4 15.5813 4 20C4 24.4187 7.58187 28 12 28H28C32.4187 28 36 24.4187 36 20C36 15.5813 32.4187 12 28 12Z" })
});
export default SvgToggleOff;
